/* SET STATE */
export const SET_STATE_SURVEYCONCEPT = "SET_STATE_SURVEYCONCEPT"

/* SURVEYCONCEPTS */
export const GET_SURVEYCONCEPTS = "GET_SURVEYCONCEPTS"
export const GET_SURVEYCONCEPTS_SUCCESS = "GET_SURVEYCONCEPTS_SUCCESS"
export const GET_SURVEYCONCEPTS_FAIL = "GET_SURVEYCONCEPTS_FAIL"

/* SURVEYCONCEPT */
export const GET_SURVEYCONCEPT = "GET_SURVEYCONCEPT"
export const GET_SURVEYCONCEPT_SUCCESS = "GET_SURVEYCONCEPT_SUCCESS"
export const GET_SURVEYCONCEPT_FAIL = "GET_SURVEYCONCEPT_FAIL"

/**
 * ADD SURVEYCONCEPT
 */
 export const ADD_NEW_SURVEYCONCEPT = "ADD_NEW_SURVEYCONCEPT"
 export const ADD_SURVEYCONCEPT_SUCCESS = "ADD_SURVEYCONCEPT_SUCCESS"
 export const ADD_SURVEYCONCEPT_FAIL = "ADD_SURVEYCONCEPT_FAIL"

 /**
 * UPDATE SURVEYCONCEPT
 */
export const UPDATE_SURVEYCONCEPT = "UPDATE_SURVEYCONCEPT"
export const UPDATE_SURVEYCONCEPT_STATUS = "UPDATE_SURVEYCONCEPT_STATUS"
export const UPDATE_SURVEYCONCEPT_SUCCESS = "UPDATE_SURVEYCONCEPT_SUCCESS"
export const UPDATE_SURVEYCONCEPT_FAIL = "UPDATE_SURVEYCONCEPT_FAIL"

/**
 * DELETE SURVEYCONCEPT
 */
export const DELETE_SURVEYCONCEPT = "DELETE_SURVEYCONCEPT"
export const DELETE_SURVEYCONCEPT_SUCCESS = "DELETE_SURVEYCONCEPT_SUCCESS"
export const DELETE_SURVEYCONCEPT_FAIL = "DELETE_SURVEYCONCEPT_FAIL"
